let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a1OSV")).then(() => parcelRequire('7azO9'));